import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { ROUTES } from 'shared/constants/constant';
import { checkPermission } from 'shared/util/Utility';

interface IProps {
	module: string;
	permission: string;
}

// Higher-Order Component (HOC) for route protection
const ProtectedRoute: FC<IProps> = (props) => {
	const { permission, module } = props;
	// Render the route if the user has permission, otherwise, redirect
	if (!checkPermission(module, permission)) {
		// if user does not have permission, redirect to Access denied page
		return <Navigate to={ROUTES.ACCESS_DENIED} />;
	}
	return <Outlet />;
};

export default ProtectedRoute;
